import phoneText from '../assets/demo/demo-phone.json?raw';
import tabletText from '../assets/demo/demo-tablet.json?raw';

// The demo dashboards (docs/specs/demo-dashboard.md, issue #33): a tablet's and a phone's, on the
// demo driver alone, kept in the current store as an imported file is (DD-8) when the user tries the
// demo. The files are in `assets/demo/`, written as a user would write a dashboard.

export type DemoVersion = 'tablet' | 'phone';

/** Each version's file, as its text. */
export const DEMO_DASHBOARDS: Readonly<Record<DemoVersion, string>> = { tablet: tabletText, phone: phoneText };

/** How the choice of a version names each (DD-7). */
export const DEMO_VERSIONS: Readonly<Record<DemoVersion, { title: string; detail: string }>> = {
    tablet: { title: 'For a tablet', detail: 'Fills the screen, no scrolling' },
    phone: { title: 'For a phone', detail: 'Scrolls' },
};

/** "Demo", else "Demo 2", "Demo 3", …: the first name the store does not have (DD-8). */
export function demoName(taken: readonly string[]) : string {
    const names = new Set(taken);
    if (!names.has('Demo')) {
        return 'Demo';
    }

    let number = 2;
    while (names.has(`Demo ${number}`)) {
        number++;
    }

    return `Demo ${number}`;
}
